<template>
  <div ref="el">
    <!--<AppShowMutationFeedback v-if="messages.length" ref="el" :feedback-messages="messages" />-->
    <div
      v-if="messages.length || serverErrorMessages.length"
      class="mutation-feedback"
      :class="{
        [classList]: true,
        alert: feedbackMode != 'feedback',
        info: feedbackMode == 'feedback'
      }"
      role="alert"
      v-bind="$attrs"
    >
      <div
        class="icon-column"
        style="align-items: baseline"
        data-test="iconCol"
      >
        <slot name="icon"
          ><v-icon :color="feedbackMode == 'feedback' ? 'black' : 'red'" large>
            <template v-if="feedbackMode == 'form'"> $iconBell </template>
            <template v-else-if="feedbackMode == 'serverError'">
              $iconExclamationTriangle
            </template>
            <template v-else-if="feedbackMode == 'feedback'">
              $iconCircleCheck
            </template>
            <template v-else> $iconBell </template>
          </v-icon></slot
        >
      </div>
      <div class="feedbacks">
        <div data-test="mutationErrors">
          <div v-if="feedbackMode === 'form'" class="feedback-title">
            {{
              $t(
                "events:EventForm.FormValidation",
                "Please review the input",
                "Form validation error"
              )
            }}
          </div>
          <ul v-if="feedbackMode === 'form'">
            <li
              v-for="(responseMessage, index) in messages"
              :key="index + '-errors'"
            >
              {{ $t(responseMessage.errorTitle) }} -
              {{ responseMessage.errors.join("; ") }}
            </li>
          </ul>

          <ul
            v-else-if="feedbackMode === 'serverError'"
            class="feedback-server-errors"
          >
            <li
              v-for="(responseMessage, index) in serverErrorMessages"
              :key="index + '-errors'"
            >
              {{ responseMessage }}
            </li>
          </ul>

          <ul v-else-if="feedbackMode === 'feedback'">
            <li
              v-for="(responseMessage, index) in messages"
              :key="index + '-feedback'"
            >
              {{ responseMessage.text }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AppShowFormFeedbackPrototype"
};
</script>
<script setup>
import { ref, nextTick } from "vue";
//import AppShowMutationFeedback from "../elements/AppShows/AppShowMutationFeedback.vue";
import { useDisplayText } from "@/composables/display_text";
import { useTranslation } from "@/plugins/i18next/i18next";

const props = defineProps({
  classList: {
    type: String,
    default: undefined
  },
  rootElement: {
    type: String,
    default: undefined
  }
});

const { displayText } = useDisplayText();
const { t } = useTranslation();
const el = ref();

const messages = ref([]);
const serverErrorMessages = ref([]);
const feedbackMode = ref("form");

async function scrollUp() {
  await nextTick();
  el.value.scrollIntoView();

  if (props.rootElement) {
    const el = document.querySelector(props.rootElement);
    el.scroll(0, -25);
    return;
  }

  window.scrollBy(0, -25);
}

async function setServerErrorResponse(errors = null) {
  feedbackMode.value = "serverError";
  if (errors?.networkError) {
    serverErrorMessages.value = [
      t(
        "common:tehnicalError",
        "Unfortunately, system encountered a problem. Our technical team is investigating, please try again later."
      )
    ];
    await scrollUp();
    return;
  }

  if (!errors || errors.length == 0) {
    serverErrorMessages.value = ["Undefined error!"];
  }

  if (errors.graphQLErrors?.length > 0) {
    serverErrorMessages.value = errors.graphQLErrors
      .map(graphQLError => {
        if (graphQLError.type === "validationErrors") {
          return graphQLError.messages.map(m => {
            return displayText(m);
          });
        }
        if (graphQLError.key) {
          return t(graphQLError.key, graphQLError.msg || graphQLError.message);
        }

        if (graphQLError.translation_key || graphQLError.translationKey) {
          return displayText(graphQLError);
        }

        return (graphQLError.msg || graphQLError.message)
          .split("GraphQL error:")
          .join(" ");
      })
      .flat();
  }

  await scrollUp();
}

async function setPositiveFeedback(positiveMessages) {
  serverErrorMessages.value = [];
  messages.value = positiveMessages;
  feedbackMode.value = "feedback";
  await scrollUp();
}

async function setFormFeedback(errorMessages) {
  serverErrorMessages.value = [];
  feedbackMode.value = "form";
  if (errorMessages.length == 0) return;
  messages.value = errorMessages;
  await scrollUp();
}

function closeFormFeedback() {
  messages.value = [];
  serverErrorMessages.value = [];
}

defineExpose({
  setFormFeedback,
  closeFormFeedback,
  setServerErrorResponse,
  setPositiveFeedback
});
</script>
<style scoped lang="scss">
.mutation-feedback {
  .feedback-title {
    font-size: 18px;
    margin-bottom: 4px;
    font-weight: bold;

    @media (max-width: 576px) {
      font-size: 16px;
    }
  }

  display: flex;
  flex-direction: row;

  background-color: var(--v-alert-base);
  border-radius: 4px;
  padding: 16px;

  @media (max-width: 576px) {
    flex-direction: column;
  }

  .icon-column {
    width: auto;
    padding: 0 12px;

    display: flex;
    justify-content: center;
    @media (max-width: 576px) {
      width: 100%;
      display: block;
      padding: 0;
      text-align: center;
      margin-right: 0px;
      padding-bottom: 18px;
    }
  }

  .feedbacks {
    max-width: 90%;
    padding: 0 12px;

    ul {
      li {
        margin-bottom: 4px;
        font-size: 15px;
      }
    }

    .feedback-server-errors {
      list-style: none;
      padding-left: 0;
    }

    @media (max-width: 576px) {
      max-width: 100%;
      display: block;
      padding: 0;
      text-align: center;
    }
  }
}
</style>
